<template>
    <v-dialog persistent
            v-model="$store.getters.vouchersDialog"
            max-width="290">
        <v-card id="myCard">
            <v-card-title class="white--text primary">
                <h4 class="white--text primary " style="max-width: 70ch">Κωδικοί Voucher</h4>
                <v-spacer></v-spacer>
                <v-icon @click="closeDialog" color="white">close</v-icon>
            </v-card-title>
            <v-card-text>
                <v-layout row wrap justify-center class=" mt-1 pr-1 pl-1">
                    <v-flex xl10 >
                        <v-textarea readonly label="Κωδικοί Voucher" :value="vouchers" />
                    </v-flex>
                </v-layout>
                <v-layout row wrap justify-center class=" mt-1 pr-1 pl-1">
                    <v-flex xl10 >
                        <v-btn block color="primary" @click="copyToClipboard()"> copy all<v-icon class="ml-2">copy_all</v-icon></v-btn>
                    </v-flex>
                </v-layout>
                <v-layout row wrap justify-center class=" mt-1 pr-1 pl-1">
                    <v-flex xl10 >
                        <p>
                            Μπορείτε να ενημερωθείτε για την εξέλιξη της αποστολής  <a href="https://www.elta-courier.gr/search" target="_blank"><i>εδώ</i></a>
                        </p>
                    </v-flex>
                </v-layout>
            </v-card-text>

        </v-card>
    </v-dialog>
</template>

<script>
	export default {
		name: "VouchersDialog",
		props:{
			vouchers: String
		},
		data: () => ({

		}),

		methods:{

			closeDialog(){
				this.$store.commit('setVouchersDialog', false);
            },

			async copyToClipboard(){
				await navigator.clipboard.writeText(this.vouchers);
				document.getElementById("myCard").style.opacity = '0.3';
				await new Promise(r => setTimeout(r, 200));
				document.getElementById("myCard").style.opacity = '1';

            },

        },
	}
</script>

<style scoped>
</style>